import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  searchImage,
  viewNextImage,
  viewPreviousImage
} from '../../actions/SearchFieldActions';

import SearchingModal from './SearchingModal';
import Modal from '../../components/Modal';
import SegmentationSVG from './SegmentationSVG';
import InstanceEvaluation from './InstanceEvaluation';

import {
  searchParameterSelector
} from '../../selectors/SearchParameter.Selectors';
import { matchParameterSelector } from '../../selectors/RouterSelector';

import './SingleImageEvaluation.sass';

class SingleImageEvaluation extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = props;

    this.handleRetrySearch = this.handleRetrySearch.bind(this);
    this.handleModelClosed = this.handleModelClosed.bind(this);
    this.searchImageTransactionStart = this.searchImageTransactionStart.bind(this);
    this.keydownEvent = function keydown({ keyCode }) {
      if (keyCode === 37) {
        dispatch(viewPreviousImage());
      } else if (keyCode === 39) {
        dispatch(viewNextImage());
      }
    };

    window.addEventListener('keydown', this.keydownEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keydownEvent);
  }

  handleRetrySearch() {
    this.searchImageTransactionStart();
  }

  handleModelClosed() {
    const { history, query } = this.props;
    if (/\/images\/grid/.test(history.location.pathname)) {
      history.push(`/images/grid?${query}`);
    } else {
      history.push(`/images/list?${query}`);
    }
  }

  searchImageTransactionStart() {
    const { dispatch } = this.props;
    const { imageID } = matchParameterSelector(this.props);
    dispatch(searchImage(imageID));
  }

  checkParameters() {
    const {
      result: {
        url,
        width,
        height
      }
    } = this.props;
    return url && width && height;
  }

  /* Render segmentation / evaluation result */
  renderContent() {
    const { imageContent } = matchParameterSelector(this.props);
    const { result } = this.props;
    console.log(result);

    if (imageContent === 'segmentation') {
      return <SegmentationSVG {...result} />;
    } else if (imageContent === 'evaluation') {
      return <InstanceEvaluation {...result} />;
    }
    return undefined;
  }

  render() {
    const { searchType, searching } = this.props;

    return (
      <Modal
        open
        width="850pt"
        height="500pt"
        backgroundDarkness={0.7}
        className="SingleImageEvaluation"
        onClose={this.handleModelClosed}
      >
        {
          searchType === 'SINGLE_EVAL' ?
            <SearchingModal onRetry={this.handleRetrySearch}>Fetching Image</SearchingModal> :
            undefined
        }
        {
          !searching && this.checkParameters() ? this.renderContent() : 'Searching...'
        }
      </Modal>
    );
  }
}

/* Hint: Commnt out different props when using it */
SingleImageEvaluation.propTypes = {
  result: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
    // source: PropTypes.string,
    // ext: PropTypes.string,
    // jumboid: PropTypes.string,
    // timestamp: PropTypes.number,
    // batch: PropTypes.string,
  }).isRequired,
  searching: PropTypes.bool.isRequired,
  searchType: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

SingleImageEvaluation.defaultProps = {
  searchType: null
};

function mapStateToProps(store) {
  const { SearchField } = store;
  return {
    searching: SearchField.searching,
    searchType: SearchField.searchType,
    result: SearchField.imageSearchResult,
    query: queryString.stringify(searchParameterSelector(store))
    // TODO: Implement the radar-chart evaluation
  };
}

export default withRouter(connect(mapStateToProps)(SingleImageEvaluation));



// WEBPACK FOOTER //
// ./src/containers/Main/SingleImageEvaluation.jsx